import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_VideoConverter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/video-converter',
			name: 'Video Converter — Convert Videos Online. Transform Video Files Instantly to Popular Formats | Lift',
			description:
				'Convert videos between formats effortlessly with Lift video converter. No watermark. Upload video, choose your output format, and download in seconds. Try now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/video-converter#product' },
				{ '@id': 'https://liftapp.ai/video-converter#howto' },
				{ '@id': 'https://liftapp.ai/video-converter#benefits' },
				{ '@id': 'https://liftapp.ai/video-converter#faq' },
				{ '@id': 'https://liftapp.ai/video-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/video-converter#explore-tools' },
				{ '@id': 'https://liftapp.ai/video-converter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/video-converter#product',
			name: 'Video Format Converter Online',
			description:
				"Convert videos between popular formats with ease. Transform your video files seamlessly while maintaining quality. Try Lift's video converter now!",
			url: 'https://liftapp.ai/video-converter',
			fileFormat: [
				'video/mp4',
				'video/quicktime',
				'video/x-msvideo',
				'video/webm',
				'video/x-matroska',
				'video/mpeg',
			],
			memoryRequirements: 'Max file size: 500MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/video-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your Video',
					text: 'Drag and drop a video file from your device.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose an Output Format',
					text: "Select your desired output format — we'll handle the conversion automatically.",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Download Your File',
					text: 'Get your converted video in seconds. Download a high-quality file ready to use anywhere.',
				},
			],
		},
		// benefits
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/video-converter#benefits',
			name: 'Who can benefit from Video Converter?',
			description:
				'Lift Video Converter helps anyone convert video files between formats while preserving quality. No quality loss, wide format support, simple 3-step process.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'No Quality Loss — Our online video converter preserves your video quality.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Wide Format Support — Convert between MP4, MOV, AVI, WEBM, MKV, and more.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Simple 3-Step Process — Upload, convert, and download in seconds.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'All-in-One Tool — Edit videos, generate AI content, and optimize files in one place.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Cross-Platform Access — Use on iOS, Android, or Web anywhere, anytime.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Video format converter tool',
				description: 'Video format converter — Lift',
			},
		},
		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/video-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'How does Lift video converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Lift's online video converter uses advanced algorithms to transform your video files seamlessly between formats. Simply upload your file, select your desired output format (MP4, MOV, AVI, WEBM, MKV, or MPEG), and our tool automatically processes it while preserving quality. Download your converted video in seconds — no technical skills required.",
					},
				},
				{
					'@type': 'Question',
					name: 'Will the video lose quality after conversion?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "No. Lift's video converter is designed to maintain maximum video quality during the conversion process. We use optimized encoding techniques to ensure your files remain clear and sharp, without compromising visual fidelity.",
					},
				},
				{
					'@type': 'Question',
					name: 'What video formats does Lift support?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift supports conversion between all major video file formats including MP4, MOV, AVI, WEBM, MKV, and MPEG. You can convert from any supported format to any other, giving you complete flexibility for your video file conversion needs.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. Lift prioritizes your privacy and security. All video file conversions are processed securely, and we don't store or share your videos. Your converted files are available only to you.",
					},
				},
			],
		},
		// why-lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/video-converter#why-lift',
			name: "Why Lift's Video Converter stands out",
			description:
				"Discover the advantages of Lift's video format converter: no quality loss, wide format support, simple 3-step process, all-in-one tool, and cross-platform access.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'No Quality Loss',
					description:
						'Our online video converter preserves your video quality. Convert files without compromising resolution, clarity, or color accuracy.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Wide Format Support',
					description:
						"Convert video files between MP4, MOV, AVI, WEBM, MKV, and MPEG. Lift's video converter handles all major formats for complete flexibility.",
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Simple 3-Step Process',
					description:
						'Upload, convert, and download. Our video converter is designed for ease — transform video files in seconds with zero learning curve.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'All-in-One Tool',
					description:
						'Beyond format conversion, Lift lets you edit videos, generate AI content, and optimize files all in one place. Complete video file converter solution.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Cross-Platform Access',
					description:
						'Use our online video converter on iOS, Android, or Web. Convert video files anywhere, anytime with seamless cloud-based processing.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyLift.b11abf6c.webp',
				name: 'How to convert video format online',
				description: 'How to convert video format online — Lift.',
			},
		},
		// explore-tools
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/video-converter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		// all-in-one
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/video-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Video Converter',
					item: 'https://liftapp.ai/video-converter',
				},
			],
		},
	],
};
